import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({
  interest = "beta",
  dark = false,
  cta = "Join the Beta Waitlist",
  testid = "waitlist",
  compact = true,
}) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      toast.error("Please enter a valid work email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, { email: value, interest });
      setDone(true);
      setEmail("");
      toast.success(
        interest === "founding"
          ? "You're on the Founding Recruiter list."
          : "You're on the beta waitlist — welcome aboard."
      );
    } catch (err) {
      const msg = err?.response?.data?.detail || "Something went wrong. Try again.";
      if (err?.response?.status === 409) {
        setDone(true);
        toast(msg);
      } else {
        toast.error(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  const wrap = compact
    ? `flex flex-col sm:flex-row items-stretch gap-3 p-2 rounded-full ${
        dark ? "glass-dark" : "glass-light shadow-[0_10px_40px_-15px_rgba(15,30,70,0.25)]"
      }`
    : "flex flex-col gap-3";

  return (
    <form onSubmit={submit} noValidate className={wrap} data-testid={`${testid}-form`}>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@work-email.com"
        data-testid={`${testid}-email-input`}
        className={`flex-1 bg-transparent px-5 py-3.5 rounded-full outline-none font-display text-base ${
          dark
            ? "text-white placeholder:text-electric-ice/40"
            : "text-navy-900 placeholder:text-muted-foreground/70"
        }`}
      />
      <button
        type="submit"
        disabled={loading || done}
        data-testid={`${testid}-submit-btn`}
        className="btn-glow group inline-flex items-center justify-center gap-2 rounded-full bg-electric px-6 py-3.5 font-display font-semibold text-white transition-[transform,box-shadow,background-color] duration-300 hover:bg-electric-bright active:scale-[0.98] disabled:opacity-70"
      >
        {loading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : done ? (
          <>
            Added <Check className="h-4 w-4" />
          </>
        ) : (
          <>
            {cta}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </>
        )}
      </button>
    </form>
  );
};

export default WaitlistForm;
